(function(){
var D     = JSON.parse(document.getElementById("lp-datos").textContent);
var CRUDO = JSON.parse(document.getElementById("lp-crudo").textContent);
var CFG   = JSON.parse(document.getElementById("lp-cfg").textContent);

/* el estado que el nucleo espera encontrar puesto */
var marcador = {}, ficha = {genero:"", regalo:0, rama:""};


function esc(s){
  return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); }
function sinAcento(s){
  return String(s || "").normalize("NFD")
    .replace(/[̀-ͯ]/g, "").toLowerCase(); }
function semNum(t){
  var h = 2166136261;
  for(var i = 0; i < t.length; i++){ h ^= t.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0; }

var NOTAS = CFG.notas || {}, ACORDES = CFG.acordes || [];
var FOTOS_SKU = JSON.parse(document.getElementById("lp-fotos").textContent);
function $(i){ return document.getElementById(i); }
function esca(s){
  return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
function comoSeLlama(d){ return d.ref || d.nombre; }
function deQuienEs(d){
  return d.casa ? "Inspirado en " + d.casa : "Velantis"; }
/* ====================================================================
   EL GUION
   ==================================================================== */
var FAMILIAS = ["citrico","floral","frutal","cuero","limpio","amaderado","dulce"];

/* Cada carta reparte puntos entre familias. Nunca dice a qué huele: la
   familia es la traduccion, no la pregunta. */
var GUION = {

  quien: {
    p: "¿Para <em>quién</em> es?",
    cartas: [
      {b:"Para él",        s:"Masculino",   foto:"hombre", fam:["amaderado","cuero"],   set:{genero:"Caballero"}},
      {b:"Para ella",      s:"Femenino",    foto:"dama",   fam:["floral","dulce"],      set:{genero:"Dama"}},
      {b:"Para quien sea", s:"Sin género",  foto:"unisex", fam:["limpio","amaderado"],  set:{genero:"Unisex"}},
      {b:"Es un regalo",   s:"No es para mí", foto:"regalo", fam:[],               set:{regalo:1}, va:"regaloPara"}
    ]
  },
  regaloPara: {
    p: "¿Y para <em>quién</em> es el regalo?",
    cartas: [
      {b:"Para él",        s:"", foto:"hombre", fam:["amaderado","cuero"],  set:{genero:"Caballero"}},
      {b:"Para ella",      s:"", foto:"dama",   fam:["floral","dulce"],     set:{genero:"Dama"}},
      {b:"No estoy seguro",s:"Que le quede a cualquiera", foto:"unisex", fam:["limpio"], set:{genero:"Unisex"}}
    ]
  },

  /* La rama. Es la pregunta que mas informacion da y la unica que la
     gente contesta sin pensarlo. */
  escena: {
    p: "¿En qué <em>contexto</em> esperas que se use?",
    cartas: [
      {b:"La oficina", s:"Juntas, pasillos, café", fam:["cuero","amaderado","limpio"], foto:"escena-oficina", set:{rama:"oficina"}},
      {b:"La noche",   s:"Una cita, una cena",     fam:["dulce","cuero","floral"],     foto:"escena-noche", set:{rama:"noche"}},
      {b:"El diario",  s:"Todos los días",          fam:["limpio","citrico","frutal"],  foto:"escena-diario", set:{rama:"diario"}},
      {b:"El campus",  s:"Clases, amigos, prisa",   fam:["frutal","dulce","limpio"],    foto:"escena-campus", set:{rama:"campus"}}
    ]
  },

  /* Tres tomas por rama. Siempre entre DOS, siempre concretas, nunca
     sobre olor. */
  /* La rama de trabajo no pregunta por habitos —si llegas puntual o no— sino
     por lo que la persona quiere PROYECTAR y por el mundo donde pasa su dia.
     Cuatro opciones, no dos: son mundos, y un mundo se reconoce de un
     vistazo. */
  oficina: [
    {p:"¿Qué quieres <em>reflejar</em>?", cartas:[
      {b:"Frescura y energía", s:"Limpio, despierto, en movimiento", fam:["limpio","citrico"], foto:"ref-frescura"},
      {b:"Poder y elegancia", s:"Entras y se acomoda la sala", fam:["cuero","amaderado"], foto:"ref-poder"},
      {b:"Experiencia y tradición", s:"Alguien que ya vivió esto antes", fam:["amaderado","dulce"], foto:"ref-tradicion"},
      {b:"Confianza y calma", s:"Con quien todos quieren trabajar", fam:["dulce","limpio"], foto:"ref-calma"}]},
    {p:"¿Dónde pasa tu <em>día</em>?", cartas:[
      {b:"Un despacho de madera y cuero", s:"Libreros hasta el techo", fam:["cuero","amaderado"], foto:"ofi-despacho"},
      {b:"Un piso alto, mármol y luz", s:"Ventanales de suelo a techo", fam:["limpio","citrico"], foto:"ofi-marmol"},
      {b:"La ciudad de noche desde la ventana", s:"Las últimas luces encendidas", fam:["cuero","dulce"], foto:"ofi-noche"},
      {b:"Un loft de concreto", s:"Nada de más, todo a la vista", fam:["limpio","amaderado"], foto:"ofi-loft"}]},
    {p:"Cuando <em>ganas</em>", cartas:[
      {b:"Nadie se entera hasta el lunes", s:"Te lo guardas", fam:["amaderado","limpio"], foto:"gana-callado"},
      {b:"Se enteran desde el pasillo", s:"Y está bien", fam:["dulce","frutal"], foto:"gana-pasillo"}]}
  ],
  noche: [
    {p:"El <em>plan</em>", cartas:[
      {b:"Cena larga, mantel, poca luz", s:"Sin prisa", fam:["dulce","cuero"], foto:"noc-cena"},
      {b:"Nos vemos y ya veremos", s:"Terraza, ruido, gente", fam:["citrico","frutal"], foto:"noc-terraza"}]},
    {p:"¿Cómo te <em>arreglas</em>?", cartas:[
      {b:"Algo oscuro y con textura", s:"Y un detalle que se nota de cerca", fam:["dulce","amaderado"], foto:"noc-oscuro"},
      {b:"Algo claro y recién planchado", s:"Sin nada que sobre", fam:["limpio","floral"], foto:"noc-claro"}]},
    {p:"Al <em>entrar</em> a un lugar", cartas:[
      {b:"Que volteen desde la puerta", s:"Llegaste y se supo", fam:["dulce","frutal"], foto:"noc-puerta"},
      {b:"Que solo lo sepa quien se acerque", s:"Para poca gente", fam:["limpio","amaderado"], foto:"noc-cerca"}]}
  ],
  diario: [
    {p:"Tu <em>mañana</em>", cartas:[
      {b:"Salgo de bañarme y ya", s:"Sin ceremonia", fam:["limpio","citrico"], foto:"dia-banarse"},
      {b:"Me tomo mi tiempo", s:"Todo en su lugar", fam:["floral","amaderado"], foto:"dia-tiempo"}]},
    {p:"Tu <em>lugar</em>", cartas:[
      {b:"Playa, sal, ventana abierta", s:"Aire moviéndose", fam:["limpio","citrico"], foto:"dia-playa"},
      {b:"Bosque, lluvia, suéter", s:"Todo quieto", fam:["amaderado","cuero"], foto:"dia-bosque"}]},
    {p:"Tu <em>antojo</em>", cartas:[
      {b:"Fruta fría", s:"Recién cortada", fam:["frutal","citrico"], foto:"dia-fruta"},
      {b:"Pan dulce recién hecho", s:"Todavía tibio", fam:["dulce","amaderado"], foto:"dia-pan"}]}
  ],
  campus: [
    {p:"Tu <em>grupo</em>", cartas:[
      {b:"Los que llegan riéndose", s:"Se oyen antes de verse", fam:["frutal","dulce"], foto:"cam-grupo"},
      {b:"El que se sienta atrás", s:"Y se entera de todo", fam:["amaderado","cuero"], foto:"cam-atras"}]},
    {p:"Tu <em>prenda</em>", cartas:[
      {b:"Sudadera limpia", s:"La misma de siempre", fam:["limpio","citrico"], foto:"cam-sudadera"},
      {b:"Chamarra de piel heredada", s:"Con historia encima", fam:["cuero","amaderado"], foto:"cam-chamarra"}]},
    {p:"Al <em>salir</em>", cartas:[
      {b:"Café con leche y galleta", s:"Y a platicar", fam:["dulce","floral"], foto:"cam-cafe"},
      {b:"Cancha, sol, agua fría", s:"Y a moverse", fam:["citrico","limpio"], foto:"cam-cancha"}]}
  ],

  /* Los cuatro mundos. Son arquetipos que todo el mundo reconoce —el
     socio, el que aprende rapido, la corte, el bosque antiguo— pero con
     nombre de la casa. La auditoria de agosto se resume en «el sitio le
     presta a otras casas el espacio donde deberia construir la suya»:
     poner series de HBO en esta pantalla seria el mismo error con otro
     traje. En el mostrador la asesora si puede nombrarlas de boca. */
  /* La ultima. Antes era «si tu vida fuera una historia» con cuatro mundos
     —La Torre, El Verano, La Corte, El Bosque—: arquetipos literarios que
     no le dicen nada a quien esta parado en el mostrador y que no ayudan a
     decidir. Es el mismo problema que el CSV senalo en la de «¿como
     entras?»: una pregunta de trivia en lugar de una util.

     Esta si sirve, y es la que hace una asesora: cuanto quieres que se
     note. Ademas es el diferenciador de la casa —elixir de alta
     concentracion— dicho en palabras de la clienta, y separa de verdad las
     familias: lo que proyecta contra lo que se queda cerca. */
  mundo: {
    p: "¿Qué tanto quieres que se <em>note</em>?",
    sub:"La última. No hay respuesta correcta.",
    cartas: [
      {b:"Que entre antes que yo",   s:"Se siente desde la puerta",
       fam:["dulce","cuero","frutal"],   foto:"not-estela", set:{mundo:"Estela"}},
      {b:"Que se note, sin gritar",  s:"Lo notan cuando ya estás cerca",
       fam:["amaderado","floral"],       foto:"not-media", set:{mundo:"Presencia"}},
      {b:"Solo quien se acerque",    s:"Para poca gente, y a propósito",
       fam:["limpio","amaderado"],       foto:"not-cerca", set:{mundo:"Secreto"}},
      {b:"Que dure todo el día",     s:"Me lo pongo temprano y ya",
       fam:["amaderado","dulce","cuero"],foto:"not-dura", set:{mundo:"Fondo"}}
    ]
  }
};

/* Un arquetipo por familia dominante. Todos invariables en genero: asi
   funcionan igual para él, para ella y para quien sea. */
var ARQUETIPO = {
  cuero:     {n:"ESTRATEGA",  d:"Habla al final, una sola vez, y se acaba la junta."},
  amaderado: {n:"CENTINELA",  d:"No se mueve. Por eso todo lo demás gira alrededor."},
  citrico:   {n:"INSURGENTE", d:"Llega primero y ya nadie lo alcanza."},
  limpio:    {n:"NAVEGANTE",  d:"Trae el aire de un sitio donde tú no estabas."},
  floral:    {n:"AMANTE",     d:"Se le queda algo a quien lo abraza."},
  frutal:    {n:"CÓMPLICE",   d:"Se ríe antes del final del chiste."},
  dulce:     {n:"ALQUIMISTA", d:"Convierte una tarde cualquiera en algo que se recuerda."}
};

/* ====================================================================
   EL MOTOR DE SELECCION — portado del sitio sin tocar
   ==================================================================== */
var KW = {
  citrico:['citric','bergamot','limon','lima','naranj','mandarin','pomelo','toronj','yuzu','petitgrain','verbena','cidra','kumquat','hesperid','citron','clementina','neroli'],
  floral:['floral','flor','rosa','jazmin','azahar','iris','violeta','peonia','lirio','gardenia','tuberosa','muguete','muguet','ylang','magnolia','nardo','mimosa','fresia','freesia','geranio','loto','orquidea','heliotropo','osmanto','lavanda'],
  frutal:['frutal','manzana','pera','durazno','melocoton','frambuesa','fresa','pina','melon','lichi','grosell','ciruela','mora','chabacano','mango','cereza','membrillo','higo','uva','maracuya','guayaba','papaya','nectarina','arandano','coco','frutos rojos','ruibarbo','datil'],
  cuero:['cuero','gamuza','ante ','tabaco','suede','cuir'],
  limpio:['almizcle','musk','jabon','algodon','acuat','marino','aldehid','ozon','brisa','lluvia','fresco','limpio','menta','te blanco','lino','sal marina','notas marinas','aire'],
  amaderado:['amader','madera','cedro','sandalo','vetiver','pachul','oud','agarwood','guaiac','gaiac','roble','abedul','amberwood','ambroxan','incienso','olibano','papiro','cipres','pino','musgo','oakmoss','ebano','palo santo','haya'],
  dulce:['vainilla','caramelo','azucar','miel','chocolate','cacao','praline','malvavisco','tonka','benjui','toffee','dulce','azucarado','leche','crema','haba tonka','regaliz','melaza']
};
var STIDX = {citrico:0, floral:1, amaderado:2, dulce:3, limpio:5};
var UMBRAL = 0.30;

function tieneKW(t, ks){
  for(var i = 0; i < ks.length; i++) if(t.indexOf(ks[i]) >= 0) return true;
  return false; }
function cuentaKW(t, ks){
  var n = 0;
  for(var i = 0; i < ks.length; i++) if(t.indexOf(ks[i]) >= 0) n++;
  return n; }
function fuerza(r, nota){
  var ks = KW[nota];
  var fam = sinAcento((r[3] || "") + " " + (r[4] || ""));
  var sal = sinAcento(r[5] || ""), cor = sinAcento(r[6] || ""),
      fon = sinAcento(r[7] || "");
  var famM = tieneKW(fam, ks) ? 1 : 0;
  var pres = (tieneKW(sal, ks) ? 0.44 : 0) + (tieneKW(cor, ks) ? 0.34 : 0) +
             (tieneKW(fon, ks) ? 0.30 : 0);
  var rich = Math.min(0.18, (cuentaKW(sal, ks) + cuentaKW(cor, ks) +
                             cuentaKW(fon, ks)) * 0.035);
  var st = 0;
  if(STIDX[nota] != null){
    var dg = parseInt((r[10] || "000000")[STIDX[nota]] || "0", 10) || 0;
    st = Math.min(1, dg / 6);
  }
  return Math.max(0, Math.min(1, 0.5 * famM + 0.42 * Math.min(1, pres) +
                                 0.28 * st + rich)); }
function puntajes(i){
  var r = CRUDO[i];
  if(r.__sc) return r.__sc;
  var sc = {};
  for(var k = 0; k < FAMILIAS.length; k++) sc[FAMILIAS[k]] = fuerza(r, FAMILIAS[k]);
  r.__sc = sc;
  return sc; }
function compat(i, el){
  if(!el.length) return 0;
  var sc = puntajes(i), suma = 0, min = 1;
  for(var j = 0; j < el.length; j++){
    var v = sc[el[j]]; suma += v; if(v < min) min = v; }
  var prom = suma / el.length;
  var s = (0.15 + 0.85 * prom) * (min >= UMBRAL ? 1 : 0.9);
  return Math.max(0, Math.min(100, Math.round(s * 100))); }
function tieneTodas(i, el){
  var sc = puntajes(i);
  for(var j = 0; j < el.length; j++) if(sc[el[j]] < UMBRAL) return false;
  return true; }
function coincidencias(el, genero){
  var out = D.map(function(d){ return {d:d, pct:compat(d.i, el)}; })
    .filter(function(o){
      if(o.d.para === "Ambiental") return false;
      if(!seCobra(o.d)) return false;   /* la tienda no puede cobrarla */
      if(genero && o.d.para !== genero) return false;
      if(el.length && (o.pct <= 0 || !tieneTodas(o.d.i, el))) return false;
      return true; });
  out.sort(function(a, b){
    return b.pct - a.pct || a.d.nombre.localeCompare(b.d.nombre, "es"); });
  return out; }
function pareja(d){
  var r = CRUDO[d.i], alt = null;
  for(var i = 0; i < CRUDO.length; i++){
    var s = CRUDO[i];
    if(s[1] === "Ambiental" || s[0] === r[0]) continue;
    if(!seCobra(D[i])) continue;      /* ni de pareja: no se podría comprar */
    if(s[4] !== r[4] && s[1] === r[1]){
      if(semNum(r[0] + s[0]) % 7 === 0){ alt = D[i]; break; }
      if(!alt) alt = D[i]; } }
  return alt; }

/* == EL TRADUCTOR ====================================================
   Aqui es donde la encuesta se convierte en lo que el motor ya sabe
   leer. No cambia su logica: le entrega las tres familias mas votadas
   igual que si alguien las hubiera pulsado. Si con tres no queda nada
   —puede pasar con una mezcla rara— se prueba con dos y con una, que es
   lo mismo que haria una persona quitando una nota. */
function elegir(){
  var orden = FAMILIAS.slice().sort(function(a, b){
    return (marcador[b] || 0) - (marcador[a] || 0) ||
           FAMILIAS.indexOf(a) - FAMILIAS.indexOf(b); });
  /* Se busca un conjunto que devuelva AL MENOS TRES: en el mostrador hay
     que poder poner tres frascos sobre la barra. Con tres familias y el
     umbral de 0.30 a veces solo pasan una o dos, y entonces se quita la
     familia menos votada —que es lo mismo que haria una persona— antes
     de tocar el genero. Lo que nunca se afloja es el umbral. */
  var mejor = null;
  for(var n = 3; n >= 1; n--){
    var el = orden.slice(0, n);
    var lista = coincidencias(el, ficha.genero);
    if(lista.length >= 3) return {el:el, lista:lista, genero:ficha.genero};
    if(lista.length && !mejor) mejor = {el:el, lista:lista, genero:ficha.genero};
  }
  for(var m = 3; m >= 1; m--){
    var el2 = orden.slice(0, m);
    var l2 = coincidencias(el2, "");
    if(l2.length >= 3) return {el:el2, lista:l2, genero:""};
    if(l2.length && !mejor) mejor = {el:el2, lista:l2, genero:""};
  }
  return mejor || {el:orden.slice(0, 1), lista:coincidencias([], ""), genero:""};
}

var LECTURA = {
  citrico:   {t:"Cítrico",   m:"con filo cítrico",
              c:"abre luminoso y se mueve rápido",
              si:["la mañana","el calor","la oficina","el gimnasio"],
              no:["una cena larga","el invierno"]},
  floral:    {t:"Floral",    m:"con corazón floral",
              c:"se queda cerca, suave y elegante",
              si:["el día","la primavera","ver gente","la oficina"],
              no:["el calor extremo"]},
  frutal:    {t:"Frutal",    m:"con toque frutal",
              c:"entra alegre y se nota de lejos",
              si:["el día","el fin de semana","el verano","salir"],
              no:["una reunión formal"]},
  cuero:     {t:"De cuero",  m:"con cuero debajo",
              c:"tiene cuerpo y carácter; no pasa desapercibido",
              si:["la noche","el frío","una cena","el invierno"],
              no:["la oficina de día","el calor"]},
  limpio:    {t:"Limpio",    m:"de estela limpia",
              c:"huele a recién bañado y se queda en la piel",
              si:["el diario","la oficina","el calor","cualquier hora"],
              no:["una noche que pide presencia"]},
  amaderado: {t:"Amaderado", m:"con fondo amaderado",
              c:"cálido y seco; se sostiene todo el día",
              si:["el otoño","el invierno","la oficina","la noche"],
              no:["el mediodía de calor"]},
  dulce:     {t:"Dulce",     m:"de fondo dulce",
              c:"envuelve y deja estela",
              si:["la noche","el frío","una cita","el invierno"],
              no:["la oficina de día","el calor"]}
};
var PROYECTA = {dulce:1, frutal:1, cuero:1};

function unir(lista, tope){
  var visto = {}, out = [];
  lista.forEach(function(x){
    if(!visto[x] && out.length < tope){ visto[x] = 1; out.push(x); } });
  if(out.length <= 1) return out[0] || "";
  return out.slice(0, -1).join(", ") + " y " + out[out.length - 1];
}

function acordesDe(d, n){
  var lista = (d && ACORDES[d.i]) || [];
  return lista.slice(0, n || 7).map(function(x, i){
    return {s:x.s, t:x.t, c:x.c, p:Math.max(46, 100 - i * 5)}; });
}

/* ==========================================================================
   SOLO SE RECOMIENDA LO QUE SE PUEDE COMPRAR

   La regla de la casa en el sitio es «solo se muestra lo que se cobra». La
   encuesta se la saltaba: el motor recorre las 579 del catálogo y 13 de
   ellas no tienen variante en ninguna presentación, así que podía
   recomendar una fragancia y luego no dejar comprarla.

   Se mira contra el mismo mapa que usa el carrito: si no hay variante de
   100 ni de 50, no entra ni en las recomendaciones ni en la galería ni como
   pareja de layering.
   ========================================================================== */
function seCobra(d){
  if(!d) return false;
  var T = (CFG.tienda || {}).tallas || {};
  return !!(((T["100"] || {}).variantes || {})[d.sku] ||
            ((T["50"] || {}).variantes || {})[d.sku]);
}

/* ==========================================================================
   LA REGLA DEL REGALO, LA MISMA QUE APLICA LA CAJA

   Copiada del puente de compra del sitio (REGLA_BOLSILLO, 3-sep-2026):

       un frasco de bolsillo de 30 ml por cada 2 perfumes de 100 ml
       O por cada 3 de 50 ml. No se mezclan.

   Cuentan solo perfumes —ni ambientales, ni aceites, ni difusores, ni el
   propio regalo— y cuenta EL CARRITO ENTERO, no solo lo que se va a añadir:
   si ya hay uno de 50 ml dentro, con dos más ya son tres y entra el frasco.

   Se cuenta aquí con la misma cuenta para no prometer lo que el checkout no
   va a dar, y para poder decir exactamente qué falta.
   ========================================================================== */
var PERFUMES_NOM = null;

function nombresDePerfume(){
  if(PERFUMES_NOM) return PERFUMES_NOM;
  PERFUMES_NOM = {};
  for(var i = 0; i < CRUDO.length; i++){
    var r = CRUDO[i];
    if(r && r[0] && r[1] !== "Ambiental") PERFUMES_NOM[r[0]] = 1;
  }
  return PERFUMES_NOM;
}

function esPerfume(nombre){
  var n = String(nombre || "");
  if(n.indexOf("Bolsillo 30 ml") === 0) return false;   /* el propio regalo */
  return !!nombresDePerfume()[n];
}

function contarTallas(lista){
  var n100 = 0, n50 = 0;
  (lista || []).forEach(function(it){
    if(!it || !esPerfume(it.name)) return;
    var q = Math.max(1, parseInt(it.qty, 10) || 1);
    if(String(it.talla) === "50") n50 += q; else n100 += q;
  });
  return {n100:n100, n50:n50, ganados:Math.floor(n100 / 2) + Math.floor(n50 / 3)};
}

/* Qué falta para el siguiente frasco, dicho como en el carrito. */
function faltaPara(c){
  if(c.n100 % 2 === 1) return "una más de 100 ml";
  if(c.n50 % 3 === 2) return "una más de 50 ml";
  if(c.n50 % 3 === 1) return "dos más de 50 ml";
  return "dos de 100 ml o tres de 50 ml";
}

/* Cuántos frascos gana ESTE botón, contando lo que ya hay en el carrito. */
function regaloDelPedido(o){
  var carro = [];
  try{ carro = leerCarrito(); }catch(e){ carro = []; }
  var suma = [];
  (o.lineas || []).forEach(function(l){
    if(!l.precio) return;
    var d = porSku(l.sku);
    var r = d ? (CRUDO[d.i] || []) : [];
    suma.push({name:r[0] || l.nombre, talla:String(l.talla || "100"), qty:1});
  });
  var antes = contarTallas(carro);
  var despues = contarTallas(carro.concat(suma));
  return {antes:antes, despues:despues, nuevos:despues.ganados - antes.ganados};
}

/* ==========================================================================
   PODER VOLVER

   La encuesta solo iba hacia adelante: si alguien tocaba la carta que no
   era, no había manera de deshacerlo sin empezar de cero.

   Volver de verdad significa deshacer también lo que esa respuesta hizo: los
   puntos que repartió entre familias, el género o la rama que fijó, y las
   preguntas que metió en el plan. Por eso antes de cada respuesta se guarda
   una copia del estado y volver es recuperarla; no basta con restar uno al
   contador.
   ========================================================================== */
var HIST = [];

function guardarPaso(){
  HIST.push({m:JSON.parse(JSON.stringify(marcador)),
             f:JSON.parse(JSON.stringify(ficha)),
             p:PLAN.slice(), c:cual});
  if(HIST.length > 24) HIST.shift();
}

function olvidarPasos(){ HIST = []; }

/* Un paso atrás: deshace la última respuesta y vuelve a su pregunta. Si no
   queda ninguna, se sale a la portada. */
function atrasEncuesta(){
  if(!HIST.length){ irPantalla("portada"); return; }
  var h = HIST.pop();
  marcador = h.m; ficha = h.f; PLAN = h.p; cual = h.c;
  $("resultado").hidden = true;
  $("encuesta").hidden = false;
  render();
  irPantalla("encuesta");
}

$("qAtras").addEventListener("click", atrasEncuesta);
$("perfilAtras").addEventListener("click", atrasEncuesta);
$("notasAtras").addEventListener("click", function(){ irPantalla("portada"); });

/* ==========================================================================
   LA TERCERA, CUANDO LA PRESENTACIÓN ES DE 50 ML

   La regla de la casa regala el frasco de 30 ml por cada 2 de 100 ml o por
   cada 3 de 50 ml. Con la pareja en 50 ml faltaba una, y decirlo no basta:
   hay que ofrecerla. Aquí se proponen tres parecidas —las que siguen en la
   misma lectura del motor, descontando las dos que ya lleva— con su foto,
   se elige una y pasa a ser parte del pedido.

   Al cambiar a 100 ml la tercera se olvida: ahí el regalo entra con dos y
   añadir una más sin pedirlo sería cobrarle de más a alguien.
   ========================================================================== */
var tercera = null;

function candidatasTercera(base, par){
  var el = (resultado && resultado.el) || mezcla || [];
  var fuera = {};
  if(base) fuera[base.sku] = 1;
  if(par) fuera[par.sku] = 1;
  var l = coincidencias(el, "");
  var out = [], i;
  for(i = 0; i < l.length && out.length < 3; i++)
    if(!fuera[l[i].d.sku]) out.push(l[i].d);
  /* si la mezcla deja pocas, se completa con la pareja de la pareja */
  if(out.length < 3 && par){
    var p2 = pareja(par);
    if(p2 && !fuera[p2.sku]) out.push(p2);
  }
  return out;
}

function pintarTercera(base, par){
  var caja = $("lTercera");
  if(!caja) return;
  /* solo tiene sentido con la de 50 ml y con pareja */
  var panel = $("panel");
  if(!par || talla !== "50"){
    caja.hidden = true; caja.innerHTML = "";
    if(panel) panel.classList.remove("conTercera");
    return;
  }
  var cand = candidatasTercera(base, par);
  if(!cand.length){
    caja.hidden = true; caja.innerHTML = "";
    if(panel) panel.classList.remove("conTercera");
    return;
  }
  caja.hidden = false;
  /* con el selector puesto hay un bloque más en pantalla: el panel se aprieta */
  if(panel) panel.classList.add("conTercera");
  caja.innerHTML = '<span class="rot">Elige la tercera y te llevas un frasco de ' +
    "30 ml de regalo</span>" +
    '<div class="terFila">' + cand.map(function(d, i){
      var sel = tercera && tercera.sku === d.sku;
      return '<button class="ter' + (sel ? " sel" : "") + '" type="button" data-ter="' + i + '">' +
        '<span class="mini terFoto" data-t="' + i + '"></span>' +
        '<span class="terN"><b>' + esca(comoSeLlama(d)) + "</b></span></button>";
    }).join("") + "</div>";
  caja._cand = cand;
  [].forEach.call(caja.querySelectorAll(".terFoto"), function(m){
    miniatura(m, cand[+m.dataset.t]); });
}

/* La tercera también se ve en la composición, para que las tres estén a la
   vista antes de pagar. */
function pintarTerceraFoto(){
  var caja = $("lTerFoto"), duo = $("duo");
  if(!caja || !duo) return;
  caja.innerHTML = "";
  caja.classList.remove("conFoto");
  caja.style.removeProperty("--aura");
  duo.classList.toggle("con3", !!tercera);
  var panel = $("panel");
  if(panel) panel.classList.toggle("con3", !!tercera);
  if(tercera) miniatura(caja, tercera);
  var n = $("lTerNom"), li = $("lTerLinea");
  if(n) n.textContent = tercera ? comoSeLlama(tercera) : "";
  if(li) li.hidden = !tercera;
}

$("lTercera").addEventListener("click", function(e){
  var b = e.target.closest("[data-ter]");
  if(!b) return;
  var cand = $("lTercera")._cand || [];
  var d = cand[+b.dataset.ter];
  if(!d) return;
  tercera = (tercera && tercera.sku === d.sku) ? null : d;   /* tocar otra vez la quita */
  armarFirma(resultado.recs[elegida]);
});

/* ==========================================================================
   EL DÚO CON FOTO

   En la página del layering, tocar una recomendación movía la escena de
   notas. Aquí no hay escena: se pintan las fotos de las dos fragancias
   —la que va primero y la que va encima— con las mismas miniaturas de las
   recomendaciones.
   ========================================================================== */
function pintarDuo(base, par){
  var t = $("lNombres");
  if(t) t.innerHTML = par ? 'El <span class="masTxt">layering</span>'
                          : esca(comoSeLlama(base));
  var a = $("lBaseFoto"), b = $("lParFoto");
  if(a){
    a.innerHTML = ""; a.classList.remove("conFoto"); a.style.removeProperty("--aura");
    miniatura(a, base);
  }
  if(b){
    b.innerHTML = ""; b.classList.remove("conFoto"); b.style.removeProperty("--aura");
    if(par) miniatura(b, par);
  }
}

/* ==========================================================================
   LAS PANTALLAS

   El escenario mide siempre lo mismo. Cada paso —la portada, la pregunta,
   las notas, las coincidencias, el perfil y la firma— es una pantalla;
   irPantalla() enciende una y apaga la anterior, y el CSS hace la entrada
   (se vuelve a disparar cada vez que la clase `activa` vuelve).

   `origen` recuerda por cuál de los dos caminos se llegó a la firma, para
   que el botón de regresar lleve al sitio correcto.
   ========================================================================== */
var origen = "pPerfil";

function irPantalla(id){
  var todas = document.querySelectorAll(".pantalla");
  for(var i = 0; i < todas.length; i++){
    var p = todas[i];
    if(p.id === id){
      p.classList.remove("saliendo");
      p.classList.remove("activa");
      void p.offsetWidth;                    /* reinicia las animaciones */
      p.classList.add("activa");
      p.scrollTop = 0;
    }else if(p.classList.contains("activa")){
      p.classList.remove("activa");
      p.classList.add("saliendo");
    }
  }
  document.body.dataset.pantalla = id;
  if(id === "panel"){
    var a = document.getElementById("pAtras");
    if(a) a.textContent = origen === "galeria"
      ? "Ver todas las coincidencias" : "Ver las otras dos";
  }
}

/* LA PORTADA. Doce notas de las texturas del tema, repartidas por la
   pantalla, cada una flotando a su ritmo. Se eligen de familias distintas
   para que se vea variedad, y siempre las mismas: la portada no cambia
   cada vez que se abre. */
function poblarPortada(){
  var caja = document.getElementById("portadaNotas");
  if(!caja) return;
  var fams = Object.keys(NOTAS).filter(function(k){ return k !== "_polvo" && NOTAS[k].length; }).sort();
  if(!fams.length) return;
  var h = "", n = Math.min(12, fams.length);
  for(var i = 0; i < n; i++){
    var f = fams[Math.floor(i * fams.length / n)];
    var src = NOTAS[f][0];
    /* tres franjas: arriba, abajo y —en medio— solo pegadas a los bordes,
       para que ninguna nota pise el título ni los botones */
    var fila = Math.floor(i / 4), col = i % 4, x, y;
    if(fila === 1){ x = col < 2 ? 2 + col * 6 : 82 + (col - 2) * 8; y = 34 + col * 9; }
    else{ x = col * 25 + 4 + ((i * 7) % 9); y = (fila ? 74 : 4) + ((i * 5) % 12); }
    var t = 9 + (i % 5) * 1.7, d = -(i * 1.3);
    var e = 0.55 + ((i * 3) % 5) * 0.12;
    h += '<img src="' + esca(src) + '" alt="" loading="lazy" style="left:' + x + '%;top:' + y +
      '%;--t:' + t + 's;--d:' + d + 's;--e:' + e + ';--g:' + ((i * 37) % 40 - 20) + 'deg">';
  }
  caja.innerHTML = h;
}

document.getElementById("pAtras").addEventListener("click", function(){
  irPantalla(origen);
});
document.getElementById("empezar").addEventListener("click", function(){
  origen = "pPerfil";
  irPantalla("encuesta");
});
poblarPortada();
document.body.dataset.pantalla = "portada";

/* ==========================================================================
   EL SEGUNDO CAMINO: ELEGIR LAS NOTAS

   La encuesta es para quien no sabe por dónde empezar. Esto es para quien
   ya lo sabe: «algo floral», «algo amaderado». Es el mismo buscador que
   vive en la portada del sitio —las siete notas, los mismos filtros, el
   mismo motor y el mismo umbral—, contado con las piezas de esta sección:
   medallones, animación y la misma salida al layering y al carrito.

   No hay motor nuevo. `coincidencias(mezcla, genero)` es exactamente lo
   que el buscador llama cuando alguien pulsa una nota; aquí se le entrega
   la mezcla en vez de deducirla de las respuestas.
   ========================================================================== */

/* Las siete de la portada, con la textura del tema que mejor las dice. */
var FAM_CARTA = [
  {k:"citrico",   t:"Cítrico",   d:"Fresco y luminoso",     tex:"limon"},
  {k:"floral",    t:"Floral",    d:"Elegante y romántico",  tex:"rosa"},
  {k:"frutal",    t:"Frutal",    d:"Jugoso y vibrante",     tex:"durazno"},
  {k:"dulce",     t:"Dulce",     d:"Goloso y envolvente",   tex:"gourmand"},
  {k:"amaderado", t:"Amaderado", d:"Cálido y seco",         tex:"maderas"},
  {k:"cuero",     t:"Cuero",     d:"Con carácter",          tex:"cuero"},
  {k:"limpio",    t:"Limpio",    d:"Suave y aireado",       tex:"acuatico"}
];

var mezcla = [], generoNotas = "", buscar = "", filFam = "", filNota = "";
var listaGal = [];

function texturaDe(nombre){
  var g = NOTAS[nombre] || NOTAS.floral || NOTAS._polvo || [];
  return g.length ? g[0] : "";
}

/* ==========================================================================
   LA FAMILIA OLFATIVA

   El catálogo trae VEINTE grafías para diez familias: «Oriental»,
   «Orientales» y «Oriental / Ámbar» son la misma; «Amaderada»,
   «Amaderado» y «Amaderados» también; y «Almistle,» es un dedazo de
   Almizcle. El buscador de la portada lista las grafías tal cual, así que
   elegir una deja fuera a sus hermanas. Aquí se agrupan por su raíz.
   ========================================================================== */
var CANON_FAM = {
  "oriental ambar":"Oriental / Ámbar", "oriental":"Oriental / Ámbar",
  "orientales":"Oriental / Ámbar",
  "amaderada":"Amaderada", "amaderado":"Amaderada", "amaderados":"Amaderada",
  "floral":"Floral", "florales":"Floral",
  "aromatica fougere":"Aromática / Fougère", "aromatica":"Aromática / Fougère",
  "aromaticos":"Aromática / Fougère",
  "citrica":"Cítrica", "chipre":"Chipre", "cuero":"Cuero",
  "almizcle":"Almizcle", "almistle":"Almizcle",
  "frutal gourmand":"Frutal / Gourmand", "gourmand":"Frutal / Gourmand",
  "acuatica":"Acuática"
};

function famDe(d){
  var v = (CRUDO[d.i] || [])[4] || "";
  var k = sinAcento(v).replace(/[^a-z ]/g, " ").replace(/\s+/g, " ").trim();
  return CANON_FAM[k] || v;
}

/* Las notas concretas que valen la pena ofrecer: las que aparecen en cinco
   fragancias o más. Con menos, el desplegable se vuelve un directorio. */
function notasDelCatalogo(){
  var cuenta = {}, i, j, campo, trozos, t;
  for(i = 0; i < CRUDO.length; i++){
    var r = CRUDO[i];
    if(r[1] === "Ambiental") continue;
    for(campo = 5; campo <= 7; campo++){
      trozos = String(r[campo] || "").split(/[,;\/]/);
      for(j = 0; j < trozos.length; j++){
        t = trozos[j].replace(/[.\s]+$/, "").trim().toLowerCase();
        if(t.length > 2 && !/^\d+$/.test(t)) cuenta[t] = (cuenta[t] || 0) + 1;
      }
    }
  }
  var fuera = [];
  for(t in cuenta) if(cuenta[t] >= 5) fuera.push(t);
  return fuera.sort(function(a, b){ return a.localeCompare(b, "es"); });
}

function mayus(s){ return s.charAt(0).toUpperCase() + s.slice(1); }

function llenarFiltros(){
  var fams = {}, i;
  for(i = 0; i < D.length; i++){
    if((CRUDO[D[i].i] || [])[1] === "Ambiental") continue;
    var f = famDe(D[i]);
    if(f) fams[f] = 1;
  }
  var lista = Object.keys(fams).sort(function(a, b){ return a.localeCompare(b, "es"); });
  $("galFam").innerHTML = '<option value="">Todas las familias</option>' +
    lista.map(function(f){ return '<option value="' + esca(f) + '">' + esca(f) + "</option>"; }).join("");
  $("galNota").innerHTML = '<option value="">Todas las notas</option>' +
    notasDelCatalogo().map(function(n){
      return '<option value="' + esca(n) + '">' + esca(mayus(n)) + "</option>"; }).join("");
}

/* --------------------------------------------------------- las siete */
function pintarFamilias(){
  var caja = $("famGrid");
  if(!caja) return;
  caja.innerHTML = FAM_CARTA.map(function(f, i){
    var tex = texturaDe(f.tex);
    return '<button class="fam" type="button" data-fam="' + f.k + '" style="--i:' + i + '">' +
      '<span class="mini famFoto">' + (tex ? '<img class="foto" alt="" loading="lazy" src="' + esca(tex) + '">' : "") + '</span>' +
      '<span class="famN"><b>' + esca(f.t) + '</b><em>' + esca(f.d) + '</em></span></button>';
  }).join("");
  marcarFamilias();
}

/* Marcar NO vuelve a dibujar. Cambiar el innerHTML volvía a pedir las siete
   texturas y relanzaba la animación de entrada: al tocar una nota
   parpadeaban todas las demás. */
function marcarFamilias(){
  var caja = $("famGrid");
  if(!caja) return;
  [].forEach.call(caja.querySelectorAll(".fam"), function(b){
    b.classList.toggle("sel", mezcla.indexOf(b.dataset.fam) >= 0); });
  caja.classList.toggle("hayMezcla", mezcla.length > 0);
}

function nombreFam(k){
  for(var i = 0; i < FAM_CARTA.length; i++) if(FAM_CARTA[i].k === k) return FAM_CARTA[i].t;
  return k;
}

function alternarFam(k){
  var i = mezcla.indexOf(k);
  if(i >= 0) mezcla.splice(i, 1); else mezcla.push(k);
  marcarFamilias();
  refrescarCuenta();
}

/* Lo que el motor devuelve para la mezcla de ahora. Es la MISMA llamada
   que hace la encuesta al terminar; solo que aquí la mezcla la puso la
   persona con el dedo, y encima van los filtros del buscador. */
function textoDe(d){
  var r = CRUDO[d.i] || [];
  return sinAcento([r[0], r[2], r[5], r[6], r[7], r[12], d.nombre].join(" "));
}

function piramideDe(d){
  var r = CRUDO[d.i] || [];
  return sinAcento([r[5], r[6], r[7]].join(", "));
}

function listaDeMezcla(){
  var l = coincidencias(mezcla, generoNotas);
  if(filFam) l = l.filter(function(o){ return famDe(o.d) === filFam; });
  if(filNota) l = l.filter(function(o){ return piramideDe(o.d).indexOf(sinAcento(filNota)) >= 0; });
  if(buscar) l = l.filter(function(o){ return textoDe(o.d).indexOf(buscar) >= 0; });
  return l;
}

function hayFiltros(){ return !!(filFam || filNota || buscar); }

var cuentaAhora = 0, cuentaAnim = null;

function ponCuenta(n){
  var b = $("verMezcla");
  /* todo dentro de un span: el botón es flex y si no, cada trozo de texto
     sería un elemento suelto con su hueco */
  b.innerHTML = '<span>Ver mis <b class="num">' + n + '</b> coincidencias</span>';
}

/* El número sube o baja hasta el nuevo en vez de saltar: da la sensación de
   que la mezcla está viva. */
function tweenCuenta(destino){
  cancelAnimationFrame(cuentaAnim);
  var desde = cuentaAhora, t0 = 0;
  if(desde === destino){ ponCuenta(destino); return; }
  function paso(t){
    if(!t0) t0 = t;
    var k = Math.min(1, (t - t0) / 320);
    k = 1 - Math.pow(1 - k, 3);
    cuentaAhora = Math.round(desde + (destino - desde) * k);
    ponCuenta(cuentaAhora);
    if(k < 1) cuentaAnim = requestAnimationFrame(paso);
    else cuentaAhora = destino;
  }
  cuentaAnim = requestAnimationFrame(paso);
}

function refrescarCuenta(){
  var b = $("verMezcla");
  if(!b) return;
  if(!mezcla.length){
    cancelAnimationFrame(cuentaAnim);
    cuentaAhora = 0;
    b.disabled = true;
    b.textContent = "Elige al menos una nota";
    return;
  }
  var n = coincidencias(mezcla, generoNotas).length;
  b.disabled = !n;
  if(!n){
    cancelAnimationFrame(cuentaAnim);
    cuentaAhora = 0;
    b.textContent = "Nada coincide · quita una nota";
    return;
  }
  tweenCuenta(n);
}

/* ==========================================================================
   LA GALERÍA ES UNA TIRA

   No se desplaza hacia abajo ni enseña barra: es un CARRUSEL. Las tarjetas
   van en una o dos filas —las que quepan en el alto que hay— y se pasan de
   lado con el dedo o con las flechas. Lo que aún no se ve se pinta al
   acercarse al final de la tira.
   ========================================================================== */
var TANDA = 40, pintadas = 0;

/* Cuántas filas caben. No se calcula a ojo: se mide una tarjeta ya pintada,
   porque un nombre largo ocupa dos renglones y cambia el alto de la fila. */
function medirRejilla(){
  var caja = $("galRejilla");
  if(!caja) return;
  var items = caja.querySelectorAll(".gal");
  if(!items.length) return;
  var hueco = parseFloat(getComputedStyle(caja).rowGap) || 14;
  var alto = 0, i;
  for(i = 0; i < items.length && i < 12; i++) alto = Math.max(alto, items[i].offsetHeight);
  var filas = Math.max(1, Math.min(2, Math.floor((caja.clientHeight + hueco) / (alto + hueco))));
  caja.style.setProperty("--filas", filas);
  /* la cuenta se hace con las primeras; si una de más adelante trae un
     nombre más largo, la fila crece. Se comprueba de verdad y se baja. */
  if(filas > 1 && caja.scrollHeight > caja.clientHeight + 6)
    caja.style.setProperty("--filas", filas - 1);
}

function pintarChips(){
  $("galChips").innerHTML = mezcla.map(function(k){
    return '<button class="chip on" type="button" data-quita="' + k + '">' +
      esca(nombreFam(k)) + ' <span class="x">×</span></button>'; }).join("");
  $("galReset").hidden = !hayFiltros();
}

/* LAS NOTAS DE CADA UNA, ALREDEDOR DEL MEDALLÓN.
   Tres acordes de la fórmula, con la textura del tema. Llegan cerradas
   —encogidas y sin verse— y se abren cuando la tarjeta entra en la tira. */
var SITIO_NOTA = [[6, 20, -14], [95, 44, 16], [22, 92, -8]];

function notasDe(d){
  var a = acordesDe(d, 3), h = "", k;
  for(k = 0; k < a.length && k < 3; k++){
    var g = NOTAS[a[k].s] || NOTAS._polvo || [];
    if(!g.length) continue;
    var s2 = SITIO_NOTA[k];
    h += '<img class="ng" alt="" loading="lazy" src="' + esca(g[k % g.length]) +
      '" style="left:' + s2[0] + '%;top:' + s2[1] + '%;--g:' + s2[2] + 'deg;--d:' + k + '">';
  }
  return h ? '<span class="notasGal" aria-hidden="true">' + h + "</span>" : "";
}

function dibujar(caja, desde, cuantas){
  var trozo = listaGal.slice(desde, desde + cuantas);
  var html = trozo.map(function(o, k){
    var i = desde + k;
    return '<button class="gal" type="button" data-gal="' + i + '" style="--i:' + (k % 12) + '">' +
      '<span class="aro" style="--p:' + o.pct + '"><span class="mini galFoto" data-g="' + i + '"></span></span>' +
      notasDe(o.d) +
      '<span class="galPct">' + o.pct + '%</span>' +
      '<span class="galN"><b>' + esca(comoSeLlama(o.d)) + '</b>' +
      '<em>' + esca(deQuienEs(o.d)) + '</em>' +
      '<span class="sku">' + esca(o.d.sku) + '</span></span></button>';
  }).join("");
  if(desde === 0) caja.innerHTML = html;
  else caja.insertAdjacentHTML("beforeend", html);
  [].forEach.call(caja.querySelectorAll(".galFoto:empty"), function(m){
    miniatura(m, listaGal[+m.dataset.g].d); });
  pintadas = Math.min(listaGal.length, desde + cuantas);
  vigilar(caja);
}

/* EL VIGÍA. Abre la tarjeta cuando entra en la tira y la cierra cuando sale,
   para que la animación se vea cada vez que se pasa por delante. */
var OJO = null;

function vigilar(caja){
  if(!window.IntersectionObserver) return;
  if(!OJO) OJO = new IntersectionObserver(function(vistas){
    vistas.forEach(function(v){
      v.target.classList.toggle("abierta", v.isIntersecting); });
  }, {root:caja, threshold:0.55});
  [].forEach.call(caja.querySelectorAll(".gal:not([data-visto])"), function(g){
    g.dataset.visto = "1"; OJO.observe(g); });
}

/* Las flechas mueven la tira casi una pantalla. */
function moverTira(dir){
  var caja = $("galRejilla");
  caja.scrollBy({left:dir * caja.clientWidth * 0.9, behavior:"smooth"});
}

function estadoFlechas(){
  var caja = $("galRejilla");
  var fin = caja.scrollWidth - caja.clientWidth;
  $("galPaso").hidden = fin <= 2;
  $("galAntes").disabled = caja.scrollLeft <= 2;
  $("galMas").disabled = caja.scrollLeft >= fin - 2;
}

function pintarGaleria(){
  var caja = $("galRejilla");
  if(!caja) return;
  /* PRIMERO la cabecera. Si se mide la tira antes de escribir el título, las
     fichas y el conteo, se mide contra un hueco que después encoge, y la
     tira sale con una fila de más. */
  var nombres = mezcla.map(nombreFam);
  $("galTitulo").innerHTML = nombres.length
    ? nombres.map(esca).join(' <span class="masTxt">+</span> ') : "Todo el catálogo";
  $("galCuenta").textContent = listaGal.length
    ? listaGal.length + " coincidencias · desliza y toca una para ver con cuál combina"
    : "Nada coincide · quita una nota o afloja los filtros";
  pintarChips();
  caja.classList.toggle("pocas", listaGal.length > 0 && listaGal.length <= 4);
  caja.scrollLeft = 0;
  dibujar(caja, 0, TANDA);
  medirRejilla();
  estadoFlechas();
  /* La letra de la casa llega tarde (font-display:swap) y al cambiarla los
     nombres pasan de uno a dos renglones: hay que volver a medir cuando ya
     está puesta, o la tira sale con una fila de más. */
  if(document.fonts && document.fonts.ready)
    document.fonts.ready.then(function(){ medirRejilla(); estadoFlechas(); });
  setTimeout(function(){ medirRejilla(); estadoFlechas(); }, 400);
}

function refrescarGaleria(){
  listaGal = listaDeMezcla(); pintarGaleria();
}

function abrirGaleria(){
  listaGal = listaDeMezcla();
  irPantalla("galeria");         /* primero se enciende: hay que poder medirla */
  pintarGaleria();
}

/* Tocar una de la galería lleva a la MISMA firma que la encuesta: el dúo,
   la presentación y el carrito. Se deja armado `resultado` para que
   cambiar de talla o de frasco de bolsillo siga funcionando igual. */
function abrirFicha(d){
  /* El bloque del resultado nace oculto y la encuesta lo destapa al revelar.
     Por este camino nadie lo destapaba: la firma existía en el DOM pero la
     pantalla salía en blanco. */
  $("resultado").hidden = false;
  resultado = {el:mezcla.slice(), recs:[d]};
  elegida = 0;
  bolsilloDe = 0;
  tercera = null;
  origen = "galeria";
  armarFirma(d);
  pintarDuo(d, pareja(d) || null);
  irPantalla("panel");
}

function reiniciarNotas(){
  mezcla = []; generoNotas = ""; buscar = ""; filFam = ""; filNota = "";
  $("galBuscar").value = ""; $("galFam").value = ""; $("galNota").value = "";
  [].forEach.call($("notaGenero").children, function(c){
    c.classList.toggle("on", !c.dataset.g); });
  marcarFamilias(); refrescarCuenta();
}

/* ------------------------------------------------------------- cableado */
$("porNotas").addEventListener("click", function(){
  origen = "galeria";
  irPantalla("notas");
});
$("famGrid").addEventListener("click", function(e){
  var b = e.target.closest("[data-fam]");
  if(b) alternarFam(b.dataset.fam);
});
$("notaGenero").addEventListener("click", function(e){
  var b = e.target.closest("[data-g]");
  if(!b) return;
  [].forEach.call($("notaGenero").children, function(c){ c.classList.remove("on"); });
  b.classList.add("on");
  generoNotas = b.dataset.g || "";
  refrescarCuenta();
});
$("verMezcla").addEventListener("click", abrirGaleria);
$("galAtras").addEventListener("click", function(){ irPantalla("notas"); });
$("galMas").addEventListener("click", function(){ moverTira(1); });
$("galAntes").addEventListener("click", function(){ moverTira(-1); });
/* al pasar la tira: se marcan las flechas y se pinta lo que viene */
$("galRejilla").addEventListener("scroll", function(){
  estadoFlechas();
  if(pintadas < listaGal.length &&
     this.scrollLeft + this.clientWidth > this.scrollWidth - 600){
    dibujar(this, pintadas, TANDA);
    /* lo recién pintado puede traer un nombre más largo */
    if(this.scrollHeight > this.clientHeight + 1)
      this.style.setProperty("--filas", 1);
  }
});
/* al cambiar el tamaño de la ventana cambia cuántas filas caben */
(function(){
  var t = null;
  window.addEventListener("resize", function(){
    clearTimeout(t);
    t = setTimeout(function(){
      if(document.body.dataset.pantalla === "galeria"){ medirRejilla(); estadoFlechas(); }
    }, 180);
  });
})();
$("galRejilla").addEventListener("click", function(e){
  var b = e.target.closest("[data-gal]");
  if(!b) return;
  var o = listaGal[+b.dataset.gal];
  if(o) abrirFicha(o.d);
});
/* quitar una nota desde la galería; si no queda ninguna, se vuelve a elegir */
/* «Elegir otra» de la firma: regresa a donde se estaba eligiendo, y lo que
   ya se añadió sigue en el carrito. */
document.addEventListener("click", function(e){
  if(e.target.closest && e.target.closest(".sumaOtra")) irPantalla(origen);
});
$("galChips").addEventListener("click", function(e){
  var b = e.target.closest("[data-quita]");
  if(!b) return;
  alternarFam(b.dataset.quita);
  if(!mezcla.length){ irPantalla("notas"); return; }
  refrescarGaleria();
});
$("galFam").addEventListener("change", function(){ filFam = this.value; refrescarGaleria(); });
$("galNota").addEventListener("change", function(){ filNota = this.value; refrescarGaleria(); });
$("galReset").addEventListener("click", function(){
  filFam = ""; filNota = ""; buscar = "";
  $("galFam").value = ""; $("galNota").value = ""; $("galBuscar").value = "";
  refrescarGaleria();
});
(function(){
  var t = null, caja = $("galBuscar");
  caja.addEventListener("input", function(){
    clearTimeout(t);
    t = setTimeout(function(){
      buscar = sinAcento(caja.value.trim());
      refrescarGaleria();
    }, 140);
  });
})();

pintarFamilias();
llenarFiltros();

/* ==========================================================================
   EL CARRITO DE LA PÁGINA

   Dentro de la portada, el carrito es el de la portada: `carritoDe()`
   devuelve el del padre y este cajón no se usa nunca. Abierta sola, esta
   página necesitaba uno propio, y tiene que ser EL MISMO carrito, no otro:

     · escribe y lee `velantis-cart`, el almacenamiento que usa la portada,
       con el mismo renglón {name, price, img, sub, qty, talla};
     · finaliza en el checkout de Shopify por el enlace de siempre
       —/cart/ID:CANTIDAD,…— con las variantes que ya trae la página.

   Así, lo que se añade aquí aparece en la portada y al revés.
   ========================================================================== */
var KEY_CARRITO = "velantis-cart";
var NOMBRE_A_SKU = null;

function mapaNombres(){
  if(NOMBRE_A_SKU) return NOMBRE_A_SKU;
  NOMBRE_A_SKU = {};
  for(var i = 0; i < CRUDO.length; i++){
    var r = CRUDO[i];
    if(r && r[0] && r[12] && !NOMBRE_A_SKU[r[0]]) NOMBRE_A_SKU[r[0]] = r[12];
  }
  return NOMBRE_A_SKU;
}

function leerCarrito(){
  var l = [];
  try{ l = JSON.parse(localStorage.getItem(KEY_CARRITO) || "[]"); }catch(e){ l = []; }
  return Array.isArray(l) ? l : [];
}

function guardarCarrito(l){
  try{ localStorage.setItem(KEY_CARRITO, JSON.stringify(l)); }catch(e){}
}

/* La variante que la tienda va a cobrar por ese renglón. */
function varianteDe(it){
  var sku = mapaNombres()[it.name];
  if(!sku) return null;
  var T = (CFG.tienda || {}).tallas || {};
  var b = T[String(it.talla || "100")] || {};
  return (b.variantes || {})[sku] || null;
}

function fotoDeNombre(nombre){
  var sku = mapaNombres()[nombre];
  return (sku && FOTOS_SKU[sku]) || "";
}

function pintarCarrito(){
  var l = leerCarrito(), caja = $("carritoLista");
  if(!caja) return;
  if(!l.length){
    caja.innerHTML = '<p class="carritoVacio">Tu carrito está vacío.</p>';
  }else{
    caja.innerHTML = l.map(function(it, i){
      var foto = fotoDeNombre(it.name);
      /* EL REGALO NO SE MANEJA A MANO. Los renglones de precio cero los pone
         la promoción —uno por cada dos perfumes— y no se pueden subir ni
         quitar desde aquí: se van solos cuando se quitan los perfumes. */
      var regalo = !(+it.price);
      return '<article class="ci' + (regalo ? " ciRegalo" : "") + '">' +
        '<span class="ciFoto' + (foto ? " conFoto" : "") + '">' +
        (foto ? '<img alt="" loading="lazy" src="' + esca(foto) + '">' : "") + "</span>" +
        '<div class="ciN"><b>' + esca(it.name) + "</b>" +
        (it.sub ? '<em>' + esca(it.sub) + "</em>" : "") +
        '<span class="ciTalla">' + esca(String(it.talla || "100")) + " ml</span>" +
        (regalo
          ? '<span class="ciPromo">Regalo de tu promoción</span>'
          : '<span class="ciMas"><button type="button" data-menos="' + i + '" aria-label="Quitar uno">−</button>' +
            "<i>" + (+it.qty || 1) + "</i>" +
            '<button type="button" data-mas="' + i + '" aria-label="Agregar uno">+</button></span>') +
        "</div>" +
        '<div class="ciD"><b>' + (regalo ? "incluido" : pesos(it.price * (+it.qty || 1))) + "</b>" +
        (regalo ? "" : '<button class="ciX" type="button" data-quitaLinea="' + i + '">Quitar</button>') +
        "</div></article>";
    }).join("");
  }
  var total = 0, faltan = 0, i;
  for(i = 0; i < l.length; i++) total += (+l[i].price || 0) * (+l[i].qty || 1);
  $("carritoTotal").textContent = pesos(total);
  faltan = ((CFG.tienda || {}).envio || 0) - total;
  $("carritoEnvio").innerHTML = !l.length ? ""
    : (faltan <= 0 ? "<b>Envío gratis incluido.</b>"
                   : "Faltan <b>" + pesos(faltan) + "</b> para el envío gratis.");
  $("carritoIr").disabled = !l.length;
}

function abrirCarrito(){
  pintarCarrito();
  $("carrito").hidden = false;
  /* dos cuadros después para que la transición arranque desde fuera */
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){ $("carrito").classList.add("abierto"); }); });
}

function cerrarCarrito(){
  $("carrito").classList.remove("abierto");
  setTimeout(function(){ $("carrito").hidden = true; }, 320);
}

function agregarLinea(item){
  var l = leerCarrito(), tl = String(item.talla || "100"), ya = null, i;
  /* nada de precio cero entra por aquí: el regalo lo pone la promoción */
  if(!(+item.price)) return;
  for(i = 0; i < l.length; i++)
    if(l[i].name === item.name && String(l[i].talla || "100") === tl){ ya = l[i]; break; }
  if(ya) ya.qty = (+ya.qty || 0) + 1;
  else l.push({name:item.name, price:item.price, img:item.img, sub:item.sub,
               qty:1, talla:tl});
  guardarCarrito(l);
  pintarCarrito();
}

/* El mismo contrato que la portada, para que `carritoDe()` no note la
   diferencia. */
window.VelantisCart = {add:agregarLinea, open:abrirCarrito, close:cerrarCarrito};

$("carritoLista").addEventListener("click", function(e){
  var b = e.target.closest("button");
  if(!b) return;
  var l = leerCarrito();
  /* por si acaso: un renglón de regalo nunca cambia de cantidad */
  var k0 = +(b.dataset.mas != null ? b.dataset.mas : b.dataset.menos != null ? b.dataset.menos : b.dataset.quitalinea);
  if(l[k0] && !(+l[k0].price)) return;
  if(b.dataset.mas != null) l[+b.dataset.mas].qty = (+l[+b.dataset.mas].qty || 1) + 1;
  else if(b.dataset.menos != null){
    var k = +b.dataset.menos;
    if((l[k].qty = (+l[k].qty || 1) - 1) <= 0) l.splice(k, 1);
  }else if(b.dataset.quitalinea != null) l.splice(+b.dataset.quitalinea, 1);
  else return;
  guardarCarrito(l);
  pintarCarrito();
});

[].forEach.call(document.querySelectorAll("[data-cerrar]"), function(b){
  b.addEventListener("click", cerrarCarrito); });

document.addEventListener("keydown", function(e){
  if(e.key === "Escape" && !$("carrito").hidden) cerrarCarrito(); });

/* FINALIZAR COMPRA. El enlace oficial de Shopify, el mismo que usa la
   portada: /cart/VARIANTE:CANTIDAD,… */
$("carritoIr").addEventListener("click", function(){
  var l = leerCarrito(), piezas = [], sinCaja = [], i;
  for(i = 0; i < l.length; i++){
    var v = varianteDe(l[i]);
    if(v) piezas.push(v + ":" + (+l[i].qty || 1));
    else if(l[i].price) sinCaja.push(l[i].name);
  }
  if(!piezas.length){
    $("carritoEnvio").innerHTML = "<b>No se puede cobrar en línea todavía.</b>";
    return;
  }
  if(sinCaja.length)
    $("carritoEnvio").innerHTML = "<b>" + esca(sinCaja[0]) +
      "</b> no se puede cobrar en línea; va el resto.";
  var dom = (CFG.tienda || {}).dominio || "velantis.mx";
  var url = "https://" + dom + "/cart/" + piezas.join(",");
  /* si algún día esto viviera en un marco de otro dominio, `top` no se deja
     tocar: entonces se navega el propio marco */
  try{ window.top.location.href = url; }catch(e){ window.location.href = url; }
});

pintarCarrito();

/* ==========================================================================
   LAS SALIDAS: LO QUE ESTÁ FUERA DE LA ENCUESTA

   Dentro de la portada, la encuesta vive en un marco. Un enlace normal
   navega ESE marco, y Shopify manda `X-Frame-Options: DENY` en todas sus
   páginas: al tocar «Ver catálogo completo» el visitante veía
   «velantis.mx rechazó la conexión» justo donde estaba la encuesta.

   Aquí las salidas se resuelven sin navegar a ningún lado:

     · «Ver catálogo completo» baja LA PÁGINA DE ATRÁS hasta el catálogo y
       deja la encuesta intacta, como estaba;
     · «Ver carrito» abre el cajón del sitio, que es el mismo carrito.

   Abierta sola la página no hay marco, y entonces sí navega, siempre al
   tope de la ventana (`target="_top"`), nunca dentro del marco.
   ========================================================================== */
function dentroDeLaPortada(){
  try{
    return !!(window.parent && window.parent !== window &&
              window.parent.document && window.parent.document.getElementById);
  }catch(e){ return false; }   /* otro origen: ni mirar */
}

/* Baja la página de atrás hasta el catálogo. Devuelve si pudo. */
function llevarAlCatalogo(){
  if(!dentroDeLaPortada()) return false;
  var s;
  try{ s = window.parent.document.getElementById("catalogo"); }catch(e){ return false; }
  if(!s) return false;
  try{ s.scrollIntoView({behavior:"smooth", block:"start"}); }
  catch(e){ s.scrollIntoView(); }
  return true;
}

(function(){
  var cat = $("lCatalogo");
  if(cat){
    cat.setAttribute("href", "/#catalogo");
    cat.setAttribute("target", "_top");
    cat.addEventListener("click", function(e){
      if(llevarAlCatalogo()) e.preventDefault();
    });
  }

  var ver = document.querySelector("#carritoAviso a");
  if(ver){
    ver.setAttribute("href", "/#finder");
    ver.setAttribute("target", "_top");
    ver.addEventListener("click", function(e){
      var c = carritoDe();
      if(c && c.open){ e.preventDefault(); c.open(); }
    });
  }
})();

/* ==========================================================================
   EL SELECTOR

   Las mismas preguntas del casting de tienda —viven en `GUION`, dentro del
   nucleo extraido— y el mismo `elegir()`.
   ========================================================================== */
var PLAN = [], cual = 0;

function pantalla(){
  var k = PLAN[cual];
  return typeof k === "string" ? GUION[k] : k;
}

function pintarPasos(){
  var h = "";
  for(var i = 0; i < PLAN.length; i++)
    h += '<i class="' + (i < cual ? "ya" : i === cual ? "on" : "") + '"></i>';
  $("pasos").innerHTML = h;
}

function render(){
  var q = pantalla();
  if(!q) return revelar();
  $("pregunta").innerHTML = q.p;
  $("cartas").innerHTML = q.cartas.map(function(c, i){
    var f = c.foto && FOTOS[c.foto];
    return '<button class="carta" type="button" data-i="' + i + '">' +
      (f ? '<span class="arte"><img src="' + f.src + '" alt=""></span>' : "") +
      '<span class="linea"><b>' + esca(c.b) + '</b>' +
      (c.s ? '<span>' + esca(c.s) + '</span>' : '') +
      '</span></button>'; }).join("");
  pintarPasos();
  $("encuesta").scrollTop = 0;
}

function sumar(carta){
  (carta.fam || []).forEach(function(f, i){
    marcador[f] = (marcador[f] || 0) + (4 - i); });
  Object.keys(carta.set || {}).forEach(function(k){ ficha[k] = carta.set[k]; });
}

$("cartas").addEventListener("click", function(e){
  var b = e.target.closest("[data-i]");
  if(!b) return;
  var q = pantalla(), c = q.cartas[+b.dataset.i];
  guardarPaso();
  sumar(c);
  if(c.va) PLAN.splice(cual + 1, 0, c.va);
  if(ficha.rama && PLAN.indexOf(ficha.rama) < 0 && GUION[ficha.rama]){
    /* de la rama solo entran DOS preguntas: en una pagina que ya venia
       larga, seis toques es demasiado. Las dos primeras son las que mas
       separan. */
    var r = GUION[ficha.rama];
    PLAN.splice(cual + 1, 0, r[0], r[1]);
    ficha.rama = "";
  }
  cual++;
  render();
});

/* ------------------------------------------------------------ revelado */
var resultado = null, elegida = 0;

function revelar(){
  var r = elegir();
  var lista = r.lista.slice(0, 3);
  if(!lista.length) lista = D.slice(0, 3).map(function(d){ return {d:d}; });
  resultado = {el:r.el, recs:lista.map(function(o){ return o.d; })};

  var f1 = r.el[0], f2 = r.el[1] || r.el[0];
  var a = LECTURA[f1] || LECTURA.limpio, b = LECTURA[f2] || LECTURA.limpio;

  $("encuesta").hidden = true;
  $("resultado").hidden = false;
  $("pasos").innerHTML = "";

  $("pTitulo").textContent = a.t + (f2 !== f1 ? " " + b.m : "");
  $("pQueEs").innerHTML = "Es un aroma que <b>" + esca(a.c) + "</b>" +
    (f2 !== f1 ? ", " + esca(b.c) : "") + ". " +
    (PROYECTA[f1] ? "Se nota antes de que llegues."
                  : "Se descubre de cerca, no se anuncia.");
  $("pSi").textContent = unir(a.si.concat(b.si), 4);
  $("pNo").textContent = unir(a.no.concat(b.no), 3);

  $("pRecs").innerHTML = resultado.recs.map(function(d, k){
    return '<button class="rec" type="button" data-elige="' + k + '">' +
      '<span class="mini" data-rec="' + k + '"></span>' +
      '<div class="n"><b>' + esca(comoSeLlama(d)) + '</b>' +
      '<em>' + esca(deQuienEs(d)) + '</em>' +
      '<span class="sku">' + esca(d.sku) + '</span></div></button>';
  }).join("");
  [].forEach.call($("pRecs").querySelectorAll(".mini"), function(m){
    miniatura(m, resultado.recs[+m.dataset.rec]); });

  talla = tallaDeArranque();
  $("panel").classList.add("espera");
  origen = "pPerfil";
  irPantalla("pPerfil");
}

/* La miniatura de cada recomendacion se arma con las MISMAS piezas, en
   pequeno: tres notas y el frasco, tambien en el DOM. Que sea el mismo
   material es lo que hace que la tarjeta se lea como un trozo de la escena
   de arriba y no como otra cosa pegada debajo. */
function fotoDe(d){ return (d && FOTOS_SKU[d.sku]) || ""; }
function miniatura(caja, d){
  if(!d) return;
  var foto = fotoDe(d);
  if(foto){
    caja.classList.add("conFoto");
    caja.innerHTML = '<img class="foto" alt="" loading="lazy" src="' + esca(foto) + '">';
    var a0 = acordesDe(d, 1)[0];
    if(a0 && a0.c) caja.style.setProperty("--aura", a0.c);
    return;
  }
  var a = acordesDe(d, 3), h = "";
  var sitio = [[26, 28, 0.95, -14], [76, 42, 0.72, 17], [48, 76, 0.58, -6]];
  a.forEach(function(nt, k){
    var g = NOTAS[nt.s] || NOTAS._polvo || [];
    if(!g.length || !sitio[k]) return;
    var s = sitio[k];
    h += '<img class="mn" alt="" src="' + g[k % g.length] + '" style="left:' +
      s[0] + '%;top:' + s[1] + '%;--e:' + s[2] + ';--g:' + s[3] + 'deg">';
  });
  h += '<img class="mf" alt="" src="' + CFG.frasco + '">';
  caja.innerHTML = h;
  if(a[0] && a[0].c) caja.style.setProperty("--aura", a[0].c);
}

/* Tocar una recomendacion rehace la firma Y toma el escenario grande: la
   escena deja de contar la historia general y pasa a ser la suya. */
$("pRecs").addEventListener("click", function(e){
  var b = e.target.closest("[data-elige]");
  if(!b) return;
  elegida = +b.dataset.elige;
  bolsilloDe = 0;                      /* cada firma empieza por el primero */
  var d = resultado.recs[elegida];
  [].forEach.call($("pRecs").querySelectorAll(".rec"), function(el){
    el.classList.toggle("sel", +el.dataset.elige === elegida); });
  armarFirma(d);

  tercera = null;
  pintarDuo(d, pareja(d) || null);
  irPantalla("panel");
});

/* ==========================================================================
   EL CIERRE: QUE SE LLEVA, QUE VA DE REGALO Y CUANTO ES

   Tres cosas que antes no estaban y que son las que convierten una
   recomendacion en un pedido:

     · el FRASCO DE BOLSILLO de 30 ml que entra al llevarse los dos, y de
       cual de los dos lo quiere quien compra —es su firma, no la nuestra,
       asi que lo elige—;
     · el RESUMEN de lo que va a la caja, con el precio que la caja va a
       cobrar de verdad. No el del catalogo: si el resumen dijera un numero
       y el checkout otro, se estaria quemando a alguien que ya habia
       decidido comprar;
     · cuanto falta para el envio gratis.
   ========================================================================== */
var bolsilloDe = 0;        /* 0 = el primero, 1 = la pareja */
var talla = "100";         /* la presentacion elegida */

function pesos(n){
  return "$" + Number(n).toLocaleString("es-MX",
    {minimumFractionDigits:0, maximumFractionDigits:0});
}

/* Lo que la tienda puede cobrar de la presentacion elegida. Si esa talla
   todavia no esta dada de alta en Shopify, `id` sale nulo y el precio cae
   al de lista —el que fijo la casa—, que es lo que hay que ensenar
   mientras tanto. */
function enTalla(d, cual){
  var T = (CFG.tienda || {}).tallas || {};
  var b = T[cual || talla] || {};
  return {id:(b.variantes || {})[d.sku] || null,
          gid:(b.gid || {})[d.sku] || null,
          precio:(b.precios || {})[d.sku] != null
                 ? b.precios[d.sku] : (b.lista || null)};
}

/* El precio del selector sale de la MISMA fuente que el del resumen: lo
   que la tienda cobra por esa fragancia en esa talla. Poniendo el de lista
   se veian dos numeros distintos para lo mismo —$390 arriba y $389 abajo—
   y eso, en la pantalla donde alguien decide pagar, se lee como un error. */
/* Las presentaciones que se ofrecen. Si la casa decidio vender una sola,
   `solo` la fija y no hay nada que elegir. */
function tallasQueVan(){
  var s = (CFG.tienda || {}).solo;
  return s ? [s] : ["50", "100"];
}

function pintarTallas(base){
  var ops = $("lTallasOps"), caja = $("lTallas");
  if(!ops) return;
  var lista = tallasQueVan();
  /* con una sola presentacion el selector sobra: elegir entre una cosa no
     es elegir, es un boton que no hace nada */
  if(caja) caja.hidden = lista.length < 2;
  if(lista.length < 2){ ops.innerHTML = ""; return; }
  ops.innerHTML = lista.map(function(k){
    var v = enTalla(base, k);
    return '<button class="opcion' + (k === talla ? " sel" : "") +
      '" type="button" data-talla="' + k + '">' +
      "<b>" + k + " ml</b><em>" +
      (v.precio == null ? "—" : pesos(v.precio)) + "</em></button>";
  }).join("");
}

/* CON CUAL SE ARRANCA.
   Con la de 100, que es la del paquete. Pero si esa talla todavia no esta
   dada de alta en Shopify, arrancar ahi deja la pantalla sin boton de pago
   —no hay variante que cobrar— y la pagina parece rota. Mientras tanto
   arranca en la que si se puede pagar, y el bloque del regalo hace de
   invitacion a subir. Se corrige sola el dia que se corra la carga. */
function tallaDeArranque(){
  var s = (CFG.tienda || {}).solo;
  if(s) return s;
  var T = (CFG.tienda || {}).tallas || {};
  var cien = (T["100"] || {}).variantes || {};
  return Object.keys(cien).length ? "100" : "50";
}

/* EL REGALO VA CON LA DE 100.
   El paquete que definio la casa es dos de 100 ml. Con la de 50 no aplica,
   y eso se dice en vez de esconderse. */
/* ==========================================================================
   LA ESCALERA

   Tres escalones: una fragancia, las dos, y las dos con el frasco de
   bolsillo. Cada uno arma su propio pedido y tiene su propio boton.

   Antes habia un solo boton, «Llevarme los dos», y quien solo queria una
   fragancia se quedaba sin forma de comprarla: la pagina la convencia de
   algo y luego le exigia el doble. Un escalon por decision deja que cada
   quien pare donde quiera, y pone el siguiente a la vista por si tienta.

   El del medio va marcado porque es el que la pagina viene contando desde
   arriba, no porque sea el mas caro.
   ========================================================================== */
function armarPedido(base, par, nivel){
  /* nivel 1 = solo la suya · 2 = el layering · 3 = el layering con regalo */
  var TIENDA = CFG.tienda || {}, BOLS = TIENDA.bolsillo || {};
  var UNICO = TIENDA.regalo || {};
  var cual = talla;   /* el regalo va con cualquier presentación */
  var lleva = nivel === 1 ? [base] : [base, par];

  var o = {nivel:nivel, talla:cual, lineas:[], completo:true, total:0,
           regalo:null, enlace:""};
  var piezas = [];
  lleva.forEach(function(x, k){
    if(!x){ o.completo = false; return; }
    var v = enTalla(x, cual);
    o.total += (v.precio || 0);
    /* El renglon se apunta AUNQUE la tienda no pueda cobrarlo todavia: la
       tarjeta tiene que ensenar que se llevaria y a que precio. Sin esto,
       el escalon de 50 ml salia en blanco —sin titulo y sin lista— porque
       esa presentacion aun no esta dada de alta, y una tarjeta vacia se lee
       como un error, no como «esto se aparta por WhatsApp». */
    o.lineas.push({gid:v.gid, papel:k ? "Encima" : "Primero",
                   sku:x.sku, nombre:comoSeLlama(x),
                   precio:v.precio, talla:cual});
    if(v.id) piezas.push(v.id + ":1");
    else o.completo = false;
  });

  if(nivel === 3 && par){
    var q = [base, par][bolsilloDe] || base;
    o.regalo = q;
    var b30 = BOLS[q.sku];
    if(o.completo && (b30 || UNICO.gid)){
      piezas.push((b30 ? b30.id : UNICO.id) + ":1");
      o.lineas.push({gid:b30 ? b30.gid : UNICO.gid,
                     papel:"Regalo del paquete", sku:q.sku + "-30",
                     fragancia:comoSeLlama(q) + " \u00b7 " + q.sku,
                     nombre:"Bolsillo 30 ml \u00b7 " + comoSeLlama(q),
                     precio:0, talla:"30"});
    }else{
      /* el frasco todavia no existe en la tienda: el escalon se ensena
         igual —es la oferta— pero se cierra por WhatsApp, que es lo que
         hoy si se puede cumplir */
      o.regaloSinAlta = true;
    }
  }

  return o;
}

var OFERTAS = [];

/* Mete la tercera en el pedido: su renglón, su precio y su variante. */
function sumarTercera(o, d){
  if(!o || !d) return;
  var v = enTalla(d, talla);
  o.lineas.push({gid:v.gid, papel:"Tercera", sku:d.sku, nombre:comoSeLlama(d),
                 precio:v.precio, talla:talla});
  o.total += (v.precio || 0);
  if(!v.id) o.completo = false;
}

/* ==========================================================================
   LA COMPRA — la misma regla que el carrito del sitio

   La promoción de la casa, tal como la aplica el carrito de la portada:

       POR CADA 2 PERFUMES, UN FRASCO DE BOLSO DE 30 ML GRATIS,
       y quien compra elige de cuál de los dos aromas lo quiere.

   No depende de la presentación: dos de 50 ml también lo destraban. La
   página del layering traía otra regla —solo desde 100 ml— y por eso aquí
   faltaba el gancho en 50 ml.

   El renglón del regalo NO se manda al carrito: lo pone la propia promoción
   cuando ve las dos fragancias. Aquí solo se anuncia y se ofrece.
   ========================================================================== */
function pintarOfertas(base, par){
  var caja = $("lOfertas");
  if(!caja) return;
  var T = CFG.tienda || {};
  OFERTAS = par ? [armarPedido(base, par, 1), armarPedido(base, par, 3)]
                : [armarPedido(base, null, 1)];
  /* la tercera, si se eligió, entra en el pedido grande */
  if(par && tercera && talla === "50") sumarTercera(OFERTAS[1], tercera);
  var iP = par ? 1 : 0, P = OFERTAS[iP], sola = OFERTAS[0];
  var h = "";

  var cuantas = P.lineas.filter(function(l){ return l.precio; }).length;
  if(P.completo){
    h += '<button class="btn grande" type="button" data-compra="' + iP + '">' +
      (cuantas > 2 ? "Añadir las tres al carrito"
                   : par ? "Añadir los dos al carrito" : "Añadir al carrito") +
      '<b>' + pesos(P.total) + "</b></button>";
  }else{
    h += '<p class="noHay">Esta presentación todavía no está disponible en línea.</p>';
  }

  /* EL REGALO, CON LA REGLA QUE APLICA LA CAJA.

     Un frasco de 30 ml por cada 2 perfumes de 100 ml o por cada 3 de 50 ml,
     sin mezclar, contando lo que ya hay en el carrito. Con la pareja en 100
     ml entra; con la pareja en 50 ml falta una tercera, y eso es lo que hay
     que decir en vez de prometer un frasco que el checkout no daría.

     El aroma del frasco se elige en el carrito, que es donde la promoción
     de la casa ya lo pregunta. */
  if(P.completo){
    var g = regaloDelPedido(P);
    if(g.nuevos >= 1){
      h += '<p class="regalo30"><b>Incluye ' + (g.antes.ganados ? "otro" : "tu") +
        " frasco de bolso de 30 ml, gratis.</b> En el carrito eliges de cuál de " +
        "los dos, o de la que les recomienda el layering.</p>";
    }else{
      h += '<p class="regalo30">Con <b>' + faltaPara(g.despues) +
        "</b> entra un frasco de bolso de 30 ml, gratis. " +
        '<button class="otra sumaOtra" type="button">Elegir otra</button></p>';
    }
  }

  var falta = (T.envio || 0) - P.total;
  var linea = falta <= 0 ? "<b>Envío gratis incluido.</b>"
                         : "Faltan <b>" + pesos(falta) + "</b> para el envío gratis.";
  h += '<p class="envio">' + linea + "</p>";

  /* la otra salida: llevarse una sola. Con el gancho a la vista, porque es
     justo lo que se pierde. */
  if(par && sola.completo){
    h += '<div class="otras"><button class="otra" type="button" data-compra="0">Solo ' +
      esca(comoSeLlama(base)) + " · " + pesos(sola.total) + "</button>" +
      '<span class="pierde">sin el frasco de 30 ml</span></div>';
  }
  caja.innerHTML = h;
}

function armarFirma(base){
  var panel = $("panel");
  if(!panel || !base) return;
  panel.classList.remove("espera");

  var par = pareja(base);
  $("lBase").textContent = comoSeLlama(base);
  $("lBaseRef").textContent = deQuienEs(base) + " \u00b7 " + base.sku;
  if(par){
    $("lPar").textContent = comoSeLlama(par);
    $("lParRef").textContent = deQuienEs(par) + " \u00b7 " + par.sku;
  }else{
    $("lPar").textContent = "Brilla sola";
    $("lParRef").textContent = "Esta no necesita compa\u00f1\u00eda.";
  }
  $("lCodigo").textContent = par
    ? "Primero el " + base.sku + " en mu\u00f1ecas y cuello; encima el "
      + par.sku + ". As\u00ed, en ese orden."
    : "El " + base.sku + ", en mu\u00f1ecas y cuello.";

  pintarTallas(base);
  pintarTercera(base, par);
  pintarTerceraFoto();
  pintarOfertas(base, par);

}

/* ==========================================================================
   AÑADIR AL CARRITO

   Reemplaza al botón de pago de la página del layering. No arma un carrito
   de Shopify ni manda a WhatsApp: escribe en el CARRITO DE LA LANDING, que
   es el que ya conoce las variantes, la presentación y la promoción del
   frasco de bolsillo.

   Dos caminos, en este orden:

     · dentro de un iframe en velantis.mx  -> window.parent.VelantisCart.add
       (mismo origen; el cajón del carrito se abre solo);
     · la página abierta sola en velantis.mx -> el mismo almacenamiento
       `velantis-cart` que lee la landing, y un aviso con «Ver carrito».

   Cada artículo lleva lo mismo que una tarjeta del catálogo:
     name  = el nombre del catálogo (CAT[0]),  con el que la landing busca la
             variante en Shopify;
     price = lo que cobra la tienda en esa presentación;
     img   = la clase de la familia (n-…), como en las tarjetas;
     sub   = la familia;
     talla = "100" o "50".

   El frasco de bolsillo de 30 ml NO se manda: es el renglón de precio cero
   y lo pone la propia promoción del carrito cuando ve dos perfumes.
   ========================================================================== */

function carritoDe(){
  try{
    if(window.parent && window.parent !== window &&
       window.parent.VelantisCart && window.parent.VelantisCart.add)
      return window.parent.VelantisCart;
  }catch(e){ /* otro origen: no se puede tocar al padre */ }
  if(window.VelantisCart && window.VelantisCart.add) return window.VelantisCart;
  return null;
}

function guardarLocal(item){
  var KEY = "velantis-cart", lista = [];
  try{
    lista = JSON.parse(localStorage.getItem(KEY) || "[]");
    if(!Array.isArray(lista)) lista = [];
  }catch(e){ lista = []; }
  var ya = null;
  for(var i = 0; i < lista.length; i++){
    var x = lista[i];
    if(x && x.name === item.name && String(x.talla || "100") === item.talla){ ya = x; break; }
  }
  if(ya) ya.qty = (+ya.qty || 0) + 1; else lista.push(item);
  try{ localStorage.setItem(KEY, JSON.stringify(lista)); }catch(e){}
}

function porSku(sku){
  for(var i = 0; i < D.length; i++) if(D[i].sku === sku) return D[i];
  return null;
}

function articuloDe(l){
  var d = porSku(l.sku);
  if(!d) return null;
  var r = CRUDO[d.i] || [];
  return {name:r[0] || comoSeLlama(d), price:+l.precio || 0,
          img:"n-" + (r[9] || ""), sub:r[3] || "", qty:1,
          talla:String(l.talla || "100")};
}

function agregarAlCarrito(boton, o){
  if(!o || !o.lineas.length || boton.dataset.ocupado) return;
  var c = carritoDe(), n = 0;
  o.lineas.forEach(function(l){
    if(!l.precio) return;                 /* el regalo lo pone el carrito */
    var it = articuloDe(l);
    if(!it) return;
    if(c) c.add(it); else guardarLocal(it);
    n++;
  });
  if(!n) return;
  boton.dataset.ocupado = "1";
  var antes = boton.textContent;
  boton.textContent = n > 1 ? "Añadidos ✓" : "Añadido ✓";
  var aviso = $("carritoAviso");
  if(aviso) aviso.hidden = !!c;
  if(c && c.open) c.open();
  setTimeout(function(){ boton.textContent = antes; delete boton.dataset.ocupado; }, 1400);
}

$("lOfertas").addEventListener("click", function(e){
  var b = e.target.closest("[data-compra]");
  if(b){ agregarAlCarrito(b, OFERTAS[+b.dataset.compra]); return; }
  /* de cual quiere el frasco de bolsillo */
  var r = e.target.closest("[data-bols]");
  if(r && resultado){
    bolsilloDe = +r.dataset.bols;
    armarFirma(resultado.recs[elegida]);
  }
});

$("lTallasOps").addEventListener("click", function(e){
  var b = e.target.closest("[data-talla]");
  if(!b || !resultado) return;
  talla = b.dataset.talla;
  if(talla !== "50") tercera = null;   /* con 100 ml no hace falta */
  armarFirma(resultado.recs[elegida]);
});

$("pOtra").addEventListener("click", function(){
  PLAN = ["quien", "escena"]; cual = 0;
  marcador = {}; ficha = {genero:"", regalo:0, rama:""};
  resultado = null; elegida = 0;
  bolsilloDe = 0; talla = tallaDeArranque();
  $("resultado").hidden = true; $("encuesta").hidden = false;
  render();
  tercera = null;
  olvidarPasos();
  reiniciarNotas();
  irPantalla("portada");
});

/* ============================================================== arranque */
var FOTOS = CFG.fotos || {};
(function(){
  PLAN = ["quien", "escena"];
  render();
  console.log("[encuesta] lista ·", D.length, "fragancias");
})();
})();
